/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L5Inputs */

const en_mk_sec_pg_l5 = /** @type {(inputs: Mk_Sec_Pg_L5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encryption in transit (HTTPS)`)
};

const id_mk_sec_pg_l5 = /** @type {(inputs: Mk_Sec_Pg_L5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enkripsi di jalur (HTTPS)`)
};

/**
* | output |
* | --- |
* | "Encryption in transit (HTTPS)" |
*
* @param {Mk_Sec_Pg_L5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l5 = /** @type {((inputs?: Mk_Sec_Pg_L5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l5(inputs)
	return en_mk_sec_pg_l5(inputs)
});